export const trackOspError = ({message}: {message: string}) => {
  const event = {
    event: 'control',
    action: 'error_osp',
    label: message,
  };

  return event;
};
